import { ReactNode, useMemo, useRef } from "react";

export interface DataCacheProps<T = any> {
    data: T | undefined,
    children?: (data: T) => ReactNode
}

export default function DataCache<T = any>({
    data,
    children
}: DataCacheProps<T>) {
    const cacheDataRef = useRef<T | undefined>(data);
    const cacheData = useMemo(() => {
        if (data === undefined) return cacheDataRef.current;
        cacheDataRef.current = data;
        return data;
    }, [data]);
    return children && children(cacheData as T);
}